var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"rotated-th",class:_vm.alignClass,style:(_vm.thStyle)},[_c('div',{staticClass:"rotated-th__inner"},[_c('span',{staticClass:"rotated-th__label"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }